export const API_ENDPOINTS = {
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  REGISTER_WITH_ORGANIZATION: '/auth/register-with-organization',
  LOGOUT: '/auth/logout',
  LOGOUT_ALL_DEVICES: '/auth/logout-all',
  CURRENT_USER: '/auth/me',
  UPDATE_PROFILE: '/auth/profile',
  CHANGE_PASSWORD: '/auth/change-password',
  TOGGLE_TWO_FACTOR: '/auth/toggle-2fa',
  SWITCH_ORGANIZATION: '/auth/switch-organization',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',
  VERIFY_RESET_TOKEN: '/auth/verify-reset-token',
  REFRESH_TOKEN: '/auth/refresh',

  VERIFY_EMAIL: '/auth/verify-email',
  RESEND_VERIFICATION: '/auth/resend-verification',
  CHECK_VERIFICATION_STATUS: '/auth/check-verification-status',

  VERIFY_OTP: '/auth/verify-otp',
  RESEND_OTP: '/auth/resend-otp',

  GET_ORGANIZATIONS: '/auth/organizations',
  GET_ROLES: '/auth/roles',
  ALL_ROLES: '/auth/all-roles',

  GET_NOTIFICATION_PREFERENCES: '/notifications/preferences',
  UPDATE_NOTIFICATION_PREFERENCES: '/notifications/preferences/update',
  RESET_NOTIFICATION_PREFERENCES: '/notifications/preferences/reset',
  TOGGLE_NOTIFICATION_PREFERENCE: '/notifications/preferences/toggle/',

  DASHBOARD: '/dashboard',
  DASHBOARD_STATS: '/dashboard/stats',
  DASHBOARD_SMS_ACTIVITY: '/dashboard/sms-activity',
  DASHBOARD_BIRTHDAYS: '/dashboard/birthdays',
  DASHBOARD_INBOX_ALERTS: '/dashboard/inbox-alerts',
  DASHBOARD_AUTOMATIONS: '/dashboard/automations',
  DASHBOARD_PLATFORM_HEALTH: '/dashboard/platform-health',
  DASHBOARD_LATEST_POLL: '/dashboard/latest-poll',
  DASHBOARD_RECENT_ACTIVITY: '/dashboard/recent-activity',
  DASHBOARD_GROUPS_SNAPSHOT: '/dashboard/groups-snapshot',

  USERS: '/users',
  USER_SHOW: (id) => `/users/show/${id}`,
  CREATE_USER: '/users/create',
  UPDATE_USER: (id) => `/users/update/${id}`,
  DELETE_USER: (id) => `/users/delete/${id}`,

  BULK_USER_ACTION: '/users/bulk',
  APPROVE_USER: (id) => `/users/${id}/approve`,
  REJECT_USER: (id) => `/users/${id}/reject`,
  ACTIVATE_USER: (id) => `/users/${id}/activate`,
  DEACTIVATE_USER: (id) => `/users/${id}/deactivate`,
  BLOCK_USER: (id) => `/users/${id}/block`,
  UNBLOCK_USER: (id) => `/users/${id}/unblock`,

  ROLES: '/roles',
  ROLE: (id) => `/roles/${id}`,
  CREATE_ROLE: '/roles/create',
  UPDATE_ROLE: (id) => `/roles/update/${id}`,
  DELETE_ROLE: (id) => `/roles/delete/${id}`,
  SYSTEM_ROLES: '/roles/system',
  ORGANIZATION_ROLES: '/roles/organization',
  SYNC_ROLE_PERMISSIONS: (roleId) => `/roles/${roleId}/permissions`,

  PERMISSIONS: '/permissions',
  PERMISSIONS_ALL: '/permissions/all',
  PERMISSIONS_CATEGORIES: '/permissions/categories',
  PERMISSIONS_STATS: '/permissions/stats',
  PERMISSIONS_BY_CATEGORY: (category) => `/permissions/category/${category}`,
  PERMISSION: (id) => `/permissions/show/${id}`,
  CREATE_PERMISSION: '/permissions/create',
  UPDATE_PERMISSION: (id) => `/permissions/update/${id}`,
  DELETE_PERMISSION: (id) => `/permissions/delete/${id}`,
  USER_PERMISSIONS: (userId) => `/permissions/user/${userId}`,
  ROLE_PERMISSIONS: (roleId) => `/permissions/role/${roleId}`,
  SYNC_USER_PERMISSIONS: '/permissions/sync-user',
  SYNC_USER_PERMISSIONS_SLUGS: '/permissions/sync-user-slugs',
  SYNC_ROLE_PERMISSIONS: (roleId) => `/permissions/role/${roleId}/sync`,
  SYNC_ROLE_PERMISSIONS_SLUGS: (roleId) => `/permissions/role/${roleId}/sync-slugs`,

  ORGANIZATIONS: '/organizations',
  ORGANIZATION: (id) => `/organizations/show/${id}`,
  CREATE_ORGANIZATION: '/organizations/create',
  UPDATE_ORGANIZATION: (id) => `/organizations/update/${id}`,
  DELETE_ORGANIZATION: (id) => `/organizations/delete/${id}`,
  ORGANIZATION_USERS: (id) => `/organizations/${id}/users`,
  ORGANIZATION_STATS: (id) => `/organizations/${id}/stats`,
  AVAILABLE_ORGANIZATIONS: '/organizations/available',

  MEMBERS: '/members',
  MEMBER: (id) => `/members/${id}`,
  MEMBER_BY_USER: (userId) => `/members/user/${userId}`,
  CREATE_MEMBER: '/members/create',
  UPDATE_MEMBER: (id) => `/members/update/${id}`,
  DELETE_MEMBER: (id) => `/members/delete/${id}`,
  BULK_DELETE_MEMBERS: '/members/bulk-delete',
  BULK_ACTION_MEMBERS: '/members/bulk-action',
  SEND_SMS_TO_MEMBER: (id) => `/members/${id}/send-sms`,
  BULK_SEND_SMS: '/members/bulk-send-sms',
  MEMBER_SMS_LOGS: (id) => `/members/${id}/sms-logs`,
  SMS_STATS: '/members/sms-stats',
  MEMBER_STATS: '/members/stats',
  MEMBERS_BY_GROUP: (group) => `/members/group/${group}`,
  EXPORT_MEMBERS: '/members/export',

  IMPORT_MEMBERS: '/members/import',
  IMPORT_HISTORY: '/members/import/history',
  IMPORT_TEMPLATE: '/members/import/template',

  BROADCASTS: '/broadcasts',
  BROADCAST: (id) => `/broadcasts/${id}`,
  CREATE_BROADCAST: '/broadcasts/create',
  UPDATE_BROADCAST: (id) => `/broadcasts/update/${id}`,
  DELETE_BROADCAST: (id) => `/broadcasts/delete/${id}`,
  CANCEL_BROADCAST: (id) => `/broadcasts/cancel/${id}`,
  RESCHEDULE_BROADCAST: (id) => `/broadcasts/reschedule/${id}`,
  BROADCAST_STATS: '/broadcasts/stats',
  BROADCAST_SMS_LOGS: (id) => `/broadcasts/${id}/sms-logs`,

  TEMPLATES: '/broadcasts/templates',
  CREATE_TEMPLATE: '/broadcasts/templates/create',
  UPDATE_TEMPLATE: (id) => `/broadcasts/templates/update/${id}`,
  DELETE_TEMPLATE: (id) => `/broadcasts/templates/delete/${id}`,
  DUPLICATE_TEMPLATE: (id) => `/broadcasts/templates/duplicate/${id}`,

  AUTOMATIONS: '/automations',
  AUTOMATION: (id) => `/automations/${id}`,
  CREATE_AUTOMATION: '/automations/create',
  UPDATE_AUTOMATION: (id) => `/automations/update/${id}`,
  DELETE_AUTOMATION: (id) => `/automations/delete/${id}`,
  TOGGLE_AUTOMATION: (id) => `/automations/toggle/${id}`,
  RUN_AUTOMATION: (id) => `/automations/run/${id}`,
  AUTOMATION_STATS: '/automations/stats',


  BIRTHDAY_MEMBERS: '/birthdays/members',
  BIRTHDAY_UPCOMING: '/birthdays/upcoming',
  BIRTHDAY_STATS: '/birthdays/stats',
  BIRTHDAY_SETTINGS: '/birthdays/settings',
  BIRTHDAY_SEND: (memberId) => `/birthdays/send/${memberId}`,
  BIRTHDAY_SEND_BULK: '/birthdays/send-bulk',
  BIRTHDAY_EXPORT: (type) => `/birthdays/export/${type}`,
  BIRTHDAY_MEMBER: (memberId) => `/birthdays/member/${memberId}`,
  BIRTHDAY_TEST: '/birthdays/test',
  BIRTHDAY_REPORT: '/birthdays/report',

  POLLS: '/polls',
  POLL: (id) => `/polls/${id}`,
  POLL_STATS: '/polls/stats',
  POLL_EXPORT: (type) => `/polls/export/${type}`,
  POLL_CREATE: '/polls/create',
  POLL_UPDATE: (id) => `/polls/update/${id}`,
  POLL_DELETE: (id) => `/polls/delete/${id}`,
  POLL_DUPLICATE: (id) => `/polls/${id}/duplicate`,
  POLL_ACTIVATE: (id) => `/polls/${id}/activate`,
  POLL_CLOSE: (id) => `/polls/${id}/close`,
  POLL_RESPONSES: (id) => `/polls/${id}/responses`,

  DEVOTIONALS: '/devotionals',
  DEVOTIONAL: (id) => `/devotionals/${id}`,
  DEVOTIONAL_STATS: '/devotionals/stats',
  DEVOTIONAL_EXPORT: (type) => `/devotionals/export/${type}`,
  DEVOTIONAL_CREATE: '/devotionals/create',
  DEVOTIONAL_UPDATE: (id) => `/devotionals/update/${id}`,
  DEVOTIONAL_DELETE: (id) => `/devotionals/delete/${id}`,
  DEVOTIONAL_DUPLICATE: (id) => `/devotionals/${id}/duplicate`,
  DEVOTIONAL_TOGGLE: (id) => `/devotionals/${id}/toggle`,
  DEVOTIONAL_SEND: (id) => `/devotionals/${id}/send`,
  DEVOTIONAL_SUBSCRIBERS: (id) => `/devotionals/${id}/subscribers`,
  DEVOTIONAL_SUBSCRIBER_REMOVE: (id, subscriberId) => `/devotionals/${id}/subscribers/${subscriberId}`,

  EVENTS: '/events',
  EVENT: (id) => `/events/${id}`,
  EVENT_STATS: '/events/stats',
  EVENT_EXPORT: (type) => `/events/export/${type}`,
  EVENT_CREATE: '/events/create',
  EVENT_UPDATE: (id) => `/events/update/${id}`,
  EVENT_DELETE: (id) => `/events/delete/${id}`,
  EVENT_DUPLICATE: (id) => `/events/${id}/duplicate`,
  EVENT_SEND_INVITES: (id) => `/events/${id}/send-invites`,
  EVENT_SEND_REMINDERS: (id) => `/events/${id}/send-reminders`,
  EVENT_COMPLETE: (id) => `/events/${id}/complete`,
  EVENT_RSVPS: (id) => `/events/${id}/rsvps`,

  INBOX: '/inbox',
  INBOX_MESSAGE: (id) => `/inbox/${id}`,
  INBOX_STATS: '/inbox/stats',
  INBOX_EXPORT: (type) => `/inbox/export/${type}`,
  INBOX_BULK_DELETE: '/inbox/bulk-delete',
  INBOX_MEMBER_MESSAGES: (memberId) => `/inbox/member/${memberId}`,
  INBOX_READ: (id) => `/inbox/${id}/read`,
  INBOX_UNREAD: (id) => `/inbox/${id}/unread`,
  INBOX_FLAG: (id) => `/inbox/${id}/flag`,
  INBOX_UNFLAG: (id) => `/inbox/${id}/unflag`,
  INBOX_ESCALATE: (id) => `/inbox/${id}/escalate`,
  INBOX_REPLY: (id) => `/inbox/${id}/reply`,

  ATTENDANCE: '/attendance',
  ATTENDANCE_STATS: '/attendance/stats',
  ATTENDANCE_AT_RISK: '/attendance/at-risk',
  ATTENDANCE_EXPORT: (type) => `/attendance/export/${type}`,
  ATTENDANCE_CHECK_IN: '/attendance/check-in',
  ATTENDANCE_BULK_CHECK_IN: '/attendance/bulk-check-in',
  ATTENDANCE_CLOSE_WINDOW: '/attendance/close-window',
  ATTENDANCE_MEMBER_HISTORY: (memberId) => `/attendance/member/${memberId}/history`,
  ATTENDANCE_RECORD: (id) => `/attendance/${id}`,

  PRAYERS: '/prayer',
  PRAYER: (id) => `/prayer/${id}`,
  PRAYER_STATS: '/prayer/stats',
  PRAYER_EXPORT: (type) => `/prayer/export/${type}`,
  PRAYER_CREATE: '/prayer/create',
  PRAYER_UPDATE: (id) => `/prayer/update/${id}`,
  PRAYER_DELETE: (id) => `/prayer/delete/${id}`,
  PRAYER_MARK_PRAYED: (id) => `/prayer/${id}/mark-prayed`,
  PRAYER_RESPOND: (id) => `/prayer/${id}/respond`,
  PRAYER_ESCALATE: (id) => `/prayer/${id}/escalate`,
  PRAYER_SEND_DIGEST: '/prayer/send-digest',
  PRAYER_SETTINGS: '/prayer/settings',
  PRAYER_SETTINGS_UPDATE: '/prayer/settings',
  PRAYER_TEMPLATE_UPDATE: '/prayer/settings/template',


  GROUPS: '/groups',
  GROUPS_STATS: '/groups/stats',
  GROUPS_EXPORT: '/groups/export',
  CREATE_GROUP: '/groups/create',
  GROUP: (id) => `/groups/${id}`,
  UPDATE_GROUP: (id) => `/groups/update/${id}`,
  DELETE_GROUP: (id) => `/groups/delete/${id}`,
  GROUP_TOGGLE: (id) => `/groups/${id}/toggle`,
  GROUP_DUPLICATE: (id) => `/groups/${id}/duplicate`,
  GROUP_MEMBERS: (id) => `/groups/${id}/members`,
  GROUP_ADD_MEMBERS: (id) => `/groups/${id}/members`,
  GROUP_REMOVE_MEMBER: (groupId, memberId) => `/groups/${groupId}/members/${memberId}`,
  GROUP_SEND_SMS: (id) => `/groups/${id}/send-sms`,

  // GROUP_MEMBERS: (groupId) => `/groups/${groupId}/members`,
  GROUP_MEMBER_STATS: (groupId) => `/groups/${groupId}/members/stats`,
  GROUP_MEMBER_CREATE: (groupId) => `/groups/${groupId}/members/create`,
  GROUP_MEMBERS_BULK: (groupId) => `/groups/${groupId}/members/bulk`,
  GROUP_MEMBER: (groupId, memberId) => `/groups/${groupId}/members/${memberId}`,
  GROUP_MEMBER_UPDATE: (groupId, memberId) => `/groups/${groupId}/members/update/${memberId}`,
  GROUP_MEMBER_DELETE: (groupId, memberId) => `/groups/${groupId}/members/delete/${memberId}`,

  BRANCHES: '/branches',
  BRANCH: (id) => `/branches/${id}`,
  CREATE_BRANCH: '/branches/create',
  UPDATE_BRANCH: (id) => `/branches/update/${id}`,
  DELETE_BRANCH: (id) => `/branches/delete/${id}`,
  BRANCH_TOGGLE: (id) => `/branches/${id}/toggle`,
  BRANCH_SEND_SMS: (id) => `/branches/${id}/sms`,
  BRANCH_BULK_SMS: '/branches/bulk-sms',
  BRANCH_STATS: '/branches/stats',
  BRANCHES_EXPORT: '/branches/export',

  SHORTCODE: '/shortcode',
  SHORTCODE_SETTINGS: '/shortcode/settings',
  SHORTCODE_FLOW: '/shortcode/flow',
  SHORTCODE_KEYWORDS: '/shortcode/keywords',
  SHORTCODE_STATS: '/shortcode/stats',
  SHORTCODE_EXPORT: '/shortcode/export',
  SHORTCODE_INCOMING: '/shortcode/incoming',

  DRIP_CAMPAIGNS: '/drip-campaigns',
  DRIP_CAMPAIGN: (id) => `/drip-campaigns/${id}`,
  CREATE_DRIP_CAMPAIGN: '/drip-campaigns/create',
  UPDATE_DRIP_CAMPAIGN: (id) => `/drip-campaigns/update/${id}`,
  DELETE_DRIP_CAMPAIGN: (id) => `/drip-campaigns/delete/${id}`,
  DRIP_CAMPAIGN_TOGGLE: (id) => `/drip-campaigns/${id}/toggle`,
  DRIP_CAMPAIGN_DUPLICATE: (id) => `/drip-campaigns/${id}/duplicate`,
  DRIP_CAMPAIGN_STATS: '/drip-campaigns/stats',
  DRIP_CAMPAIGN_ANALYTICS: (id) => `/drip-campaigns/${id}/analytics`,
  DRIP_CAMPAIGN_ENROLLMENTS: (id) => `/drip-campaigns/${id}/enrollments`,
  DRIP_CAMPAIGN_ENROLL: (id) => `/drip-campaigns/${id}/enroll`,
  DRIP_CAMPAIGN_UNENROLL: (id) => `/drip-campaigns/${id}/unenroll`,
  DRIP_CAMPAIGN_EXPORT: (id) => `/drip-campaigns/${id}/export`,
  DRIP_CAMPAIGN_BROADCAST: (id) => `/drip-campaigns/${id}/broadcast`,
  DRIP_CAMPAIGN_TRIGGER_FLOW: (id) => `/drip-campaigns/${id}/trigger-flow`,

  VISITORS: '/visitors',
  VISITOR_STATS: '/visitors/stats',
  VISITOR_SOURCES: '/visitors/sources',
  VISITOR_BULK_SMS: '/visitors/bulk-sms',
  VISITOR_CREATE: '/visitors/create',
  VISITOR: (id) => `/visitors/${id}`,
  VISITOR_UPDATE: (id) => `/visitors/update/${id}`,
  VISITOR_DELETE: (id) => `/visitors/delete/${id}`,
  VISITOR_SEND_MESSAGE: (id) => `/visitors/${id}/send-message`,
  VISITOR_CONVERT: (id) => `/visitors/${id}/convert`,
  VISITOR_RESET: (id) => `/visitors/${id}/reset`,
  VISITOR_EXPORT: (id) => `/visitors/${id}/export`,
  VISITOR_SEQUENCES: '/visitors/sequences',
  VISITOR_SEQUENCE: '/visitors/sequences/update',


  GIVING_CAMPAIGNS: '/giving-campaigns',
  GIVING_CAMPAIGN_STATS: '/giving-campaigns/stats',
  GIVING_CAMPAIGN_CREATE: '/giving-campaigns/create',
  GIVING_CAMPAIGN: (id) => `/giving-campaigns/${id}`,
  GIVING_CAMPAIGN_UPDATE: (id) => `/giving-campaigns/update/${id}`,
  GIVING_CAMPAIGN_DELETE: (id) => `/giving-campaigns/delete/${id}`,
  GIVING_CAMPAIGN_TOGGLE: (id) => `/giving-campaigns/${id}/toggle`,
  GIVING_CAMPAIGN_DUPLICATE: (id) => `/giving-campaigns/${id}/duplicate`,
  GIVING_CAMPAIGN_DONATIONS: (id) => `/giving-campaigns/${id}/donations`,
  GIVING_CAMPAIGN_ADD_DONATION: (id) => `/giving-campaigns/${id}/donations`,
  GIVING_CAMPAIGN_SEND_MESSAGE: (id) => `/giving-campaigns/${id}/send-message`,
  GIVING_CAMPAIGN_EXPORT: (id) => `/giving-campaigns/${id}/export`,
  GIVING_CAMPAIGN_CONFIRM_DONATION: (campaignId, donationId) => `/giving-campaigns/${campaignId}/donations/${donationId}/confirm`,

  CHATBOT_RULES: '/chatbot/rules',
  CHATBOT_RULE: (id) => `/chatbot/rules/${id}`,
  CHATBOT_RULE_TOGGLE: (id) => `/chatbot/rules/${id}/toggle`,
  CHATBOT_RULE_DUPLICATE: (id) => `/chatbot/rules/${id}/duplicate`,
  CHATBOT_STATS: '/chatbot/stats',
  CHATBOT_TOP_KEYWORDS: '/chatbot/top-keywords',
  CHATBOT_FALLBACK: '/chatbot/fallback',
  CHATBOT_CONVERSATIONS: '/chatbot/conversations',
  CHATBOT_WEBHOOK: '/chatbot/webhook',

  MEMBER_HEALTH_SCORES: '/member-health/scores',
  MEMBER_HEALTH_STATS: '/member-health/stats',
  MEMBER_HEALTH_AT_RISK: '/member-health/at-risk',
  MEMBER_HEALTH_ALERTS: '/member-health/alerts',
  MEMBER_HEALTH_ALERT_RESOLVE: (id) => `/member-health/alerts/${id}/resolve`,
  MEMBER_HEALTH_RULES: '/member-health/rules',
  MEMBER_HEALTH_RULE: (id) => `/member-health/rules/${id}`,
  MEMBER_HEALTH_RULE_TOGGLE: (id) => `/member-health/rules/${id}/toggle`,
  MEMBER_HEALTH_BULK_SMS: '/member-health/bulk-sms',
  MEMBER_HEALTH_GROUPS: '/member-health/groups',
  MEMBER_HEALTH_CALCULATE_SCORE: '/member-health/calculate-score',

  SENDER_IDS: '/sender-ids',
  SENDER_IDS_CREATE: '/sender-ids/create',
  SENDER_IDS_SHOW: (id) => `/sender-ids/${id}`,
  SENDER_IDS_UPDATE: (id) => `/sender-ids/update/${id}`,
  SENDER_IDS_DELETE: (id) => `/sender-ids/delete/${id}`,
  SENDER_IDS_APPROVE: (id) => `/sender-ids/${id}/approve`,
  SENDER_IDS_REJECT: (id) => `/sender-ids/${id}/reject`,
  SENDER_IDS_TOGGLE_STATUS: (id) => `/sender-ids/${id}/toggle-status`,
  SENDER_IDS_SET_DEFAULT: (id) => `/sender-ids/${id}/set-default`,
  SENDER_IDS_DEFAULT: '/sender-ids/default',

  SMS_BALANCES: '/balances',
  SMS_BALANCE_SHOW: (id) => `/balances/${id}`,
  SMS_BALANCE_ADD: (id) => `/balances/${id}/add`,
  SMS_BALANCE_DEDUCT: (id) => `/balances/${id}/deduct`,
  SMS_BALANCE_SET: (id) => `/balances/${id}/set`,
  SMS_BALANCE_TRANSACTIONS: (id) => `/balances/${id}/transactions`,

  PRICING: '/frontend/pricing',
  PRICING_SUMMARY: '/pricing/summary',
  CHANGE_PLAN: '/pricing/change-plan',

  FEATURES: '/features',
  FEATURES_EXPORT: '/features/export',
  FEATURE: (id) => `/features/${id}`,
  FEATURE_TOGGLE: (id) => `/features/${id}/toggle-status`,
  FEATURE_CREATE: '/features/create',
  FEATURE_UPDATE: (id) => `/features/update/${id}`,
  FEATURE_DELETE: (id) => `/features/delete/${id}`,

  // Testimonials
  TESTIMONIALS: '/testimonials',
  TESTIMONIALS_EXPORT: '/testimonials/export',
  TESTIMONIAL: (id) => `/testimonials/${id}`,
  TESTIMONIAL_TOGGLE: (id) => `/testimonials/${id}/toggle-status`,
  TESTIMONIAL_CREATE: '/testimonials/create',
  TESTIMONIAL_UPDATE: (id) => `/testimonials/update/${id}`,
  TESTIMONIAL_DELETE: (id) => `/testimonials/delete/${id}`,

  // Stats
  STATS: '/stats',
  STATS_EXPORT: '/stats/export',
  STAT: (id) => `/stats/${id}`,
  STAT_TOGGLE: (id) => `/stats/${id}/toggle-status`,
  STAT_CREATE: '/stats/create',
  STAT_UPDATE: (id) => `/stats/update/${id}`,
  STAT_DELETE: (id) => `/stats/delete/${id}`,

  // Regions
  REGIONS: '/regions',
  REGIONS_EXPORT: '/regions/export',
  REGION: (id) => `/regions/${id}`,
  REGION_TOGGLE: (id) => `/regions/${id}/toggle-status`,
  REGION_CREATE: '/regions/create',
  REGION_UPDATE: (id) => `/regions/update/${id}`,
  REGION_DELETE: (id) => `/regions/delete/${id}`,

  // Pricing Plans
  PRICING_PLANS: '/pricing-plans',
  PRICING_PLANS_EXPORT: '/pricing-plans/export',
  PRICING_PLAN: (id) => `/pricing-plans/${id}`,
  PRICING_PLAN_TOGGLE: (id) => `/pricing-plans/${id}/toggle-status`,
  PRICING_PLAN_CREATE: '/pricing-plans/create',
  PRICING_PLAN_UPDATE: (id) => `/pricing-plans/update/${id}`,
  PRICING_PLAN_DELETE: (id) => `/pricing-plans/delete/${id}`,

  // Blog Posts
  BLOG_POSTS: '/blog-posts',
  BLOG_POSTS_EXPORT: '/blog-posts/export',
  BLOG_POST: (id) => `/blog-posts/${id}`,
  BLOG_POST_TOGGLE: (id) => `/blog-posts/${id}/toggle-status`,
  BLOG_POST_CREATE: '/blog-posts/create',
  BLOG_POST_UPDATE: (id) => `/blog-posts/update/${id}`,
  BLOG_POST_DELETE: (id) => `/blog-posts/delete/${id}`,

  // Settings
  SETTINGS: '/settings',
  SETTING_CREATE: '/settings/create',
  SETTING_UPDATE: (key) => `/settings/update/${key}`,
  SETTING_DELETE: (key) => `/settings/delete/${key}`,
};